const config = {
  "streamer": process.env.REACT_APP_STREAMER,
  "streamerDisplayText": process.env.REACT_APP_STREAMER_DISPLAY_NAME,
  "run": process.env.REACT_APP_RUN_NAME
};

export default config;